import { Component } from '@theme/component';
import { initScrollTriggers } from 'magon-animations';
import { sectionRenderer } from '@theme/section-renderer';

// Definido uma única vez no <head> (via scripts.liquid), com o import map presente.
// Antes este código vivia inline na section magon-cart-header.liquid e era re-injetado
// a cada cart:update (renderSection) — no Safari/WebView in-app os imports bare '@theme/...'
// falhavam ("module specifier ... does not start with"). Movendo para asset, nenhum
// módulo novo é injetado no re-render: o elemento já está definido e só o markup troca.
if (!customElements.get('magon-cart-header')) {
  customElements.define(
    'magon-cart-header',
    class MagonCartHeader extends Component {
      connectedCallback() {
        super.connectedCallback();
        initScrollTriggers(this);

        // Re-renderiza a seção quando o cart muda — evita header congelado
        // mostrando contagem antiga ou estado errado (ex: "3 peças" com cart vazio)
        this._handleCartUpdate = () => {
          const sectionId = this.dataset.sectionId;
          if (sectionId && sectionRenderer) {
            sectionRenderer.renderSection(sectionId, { cache: false });
          }
        };
        document.addEventListener('cart:update', this._handleCartUpdate);
      }

      disconnectedCallback() {
        if (super.disconnectedCallback) super.disconnectedCallback();
        document.removeEventListener('cart:update', this._handleCartUpdate);
      }
    }
  );
}
